import { Component, OnInit } from "@angular/core";
import { environment } from "../environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "programadorCopec";

  ngOnInit(): void {
    this.initGoogleAnalytics(environment.googleAnalyticsId);
  }

  private initGoogleAnalytics(id: string): void {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(script);
    const inline = document.createElement("script");
    inline.text = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${id}');`;
    document.head.appendChild(inline);
  }
}
